import React from 'react';

function ErrorMessage({ fieldName, errors }) {
  console.log("fieldName", fieldName)
  console.log("errors", errors)
  
  // Handle both array and object error formats
  let error = null;
  
  if (Array.isArray(errors)) {
    // Array format: [{ field_name: 'title', message: 'Title is required' }]
    error = errors?.find(item => item?.field_name === fieldName);
  } else if (errors && typeof errors === 'object') {
    // Object format: { title: 'Title is required' }
    error = errors[fieldName] ? { message: errors[fieldName] } : null;
  }
  
  return error?.message || ""
}

export default ErrorMessage;
